import { isArray, isObject } from './typeGuards';

export function eachValue(item: unknown, callback: (value: unknown) => void) {
  if (isArray(item)) {
    item.forEach(value => {
      callback(value);
      eachValue(value, callback);
    });
  } else if (isObject(item)) {
    Object.values(item).forEach(value => {
      callback(value);
      eachValue(value, callback);
    });
  } else {
    callback(item);
  }
}
